import React from "react"
import Logo from "../components/svg/logo"
import { Link } from "gatsby"

export default function HomepageLogoLink({ passedRef, path, classes }) {
  return (
    <Link
      className={"homepage-logo-link" + (classes ? " " + classes : "")}
      to="/"
      aria-current={path === "/" ? "page" : null}
      aria-label="Go to the homepage"
      ref={passedRef ? passedRef : null}
    >
      <Logo />
      <div className="homepage-logo-link__text">
        <div className="title--quaternary title--uppercase">
          Annual Report 2020
        </div>
        <div className="title--meta title--uppercase title--light util__desktop-only">
          A Year Like No Other
        </div>
      </div>
    </Link>
  )
}
